import { render, staticRenderFns } from "./LogoFontAwesome.vue?vue&type=template&id=566ffd56&functional=true"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('566ffd56')) {
      api.createRecord('566ffd56', component.options)
    } else {
      api.rerender('566ffd56', component.options)
    }
    module.hot.accept("./LogoFontAwesome.vue?vue&type=template&id=566ffd56&functional=true", function () {
      api.rerender('566ffd56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "static/js/components-wa/branding/LogoFontAwesome.vue"
export default component.exports